type PaymentSystemWithPlatforms = {
  paymentSystem: string;
  availablePlatforms: string[];
};

export const filterPaymentSystemsForRuntime = <T extends PaymentSystemWithPlatforms>(
  payments: T[] | undefined,
  isTelegramMiniApp: boolean,
): T[] => {
  if (!payments) {
    return [];
  }

  if (isTelegramMiniApp) {
    const order = new Map([
      ['COINS', 0],
      ['TELEGRAM_STARS', 1],
    ]);

    return payments
      .filter(
        (payment) =>
          payment.availablePlatforms.includes('TELEGRAM') &&
          (payment.paymentSystem === 'COINS' || payment.paymentSystem === 'TELEGRAM_STARS'),
      )
      .sort((a, b) => (order.get(a.paymentSystem) ?? 2) - (order.get(b.paymentSystem) ?? 2));
  }

  return payments.filter(
    (payment) => payment.paymentSystem !== 'TELEGRAM_STARS' && payment.availablePlatforms.includes('WEB'),
  );
};
